import React from 'react';
import './BookBlock.css';

type BookBlockProps = {
  imageSrc?: string;
  imageAlt?: string;
  paragraphs: string[];
};

const BookBlock: React.FC<BookBlockProps> = ({
  imageSrc,
  imageAlt,
  paragraphs,
}) => (
  <div className="book-block">
    {imageSrc && <img className="book-block__image rounded" src={imageSrc} alt={imageAlt} />}
    <div className="book-block__text">
      {paragraphs.map((text, i) => (
        <p key={i} className='book-block__paragraph' dangerouslySetInnerHTML={{ __html: text }} />
      ))}
    </div>
  </div>
);

export default BookBlock;
